import React from "react";
import Snackbar from "material-ui/Snackbar";

const AlertMessage = props => {
  const { open, message, handleClose } = props;
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      onClose={handleClose}
      SnackbarContentProps={{
        "aria-describedby": "message-id"
      }}
      message={<span id="message-id">{message}</span>}
    />
  );
};

export default AlertMessage;



// WEBPACK FOOTER //
// ./src/components/AlertMessage/AlertMessage.js